import { render, staticRenderFns } from "./survey.vue?vue&type=template&id=03ee57af&scoped=true"
import script from "./survey.vue?vue&type=script&lang=js"
export * from "./survey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ee57af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03ee57af')) {
      api.createRecord('03ee57af', component.options)
    } else {
      api.reload('03ee57af', component.options)
    }
    module.hot.accept("./survey.vue?vue&type=template&id=03ee57af&scoped=true", function () {
      api.rerender('03ee57af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/storyTab/storyMaker/stiker/survey.vue"
export default component.exports